module.exports = __webpack_public_path__ + "static/media/BW.6c2cdb0c.svg";